import 'react'

import { Box, Grid, Typography } from '@mui/material'
import { GAME_TYPE, GameType } from 'constants/enums/GameTypeEnum'

import { CallToAction } from 'components/CallToAction/CallToAction'
import { GameCardSection } from 'components/GameCardSection'

import { styles } from './HomePage.styles'

const HomePage = () => {
	const warmUpGames = (Object.values(GAME_TYPE) as GameType[]).filter(
		(game) => game.gameCardPlacement === 'warmUp'
	)

	const levelUpGames = (Object.values(GAME_TYPE) as GameType[]).filter(
		(game) => game.gameCardPlacement === 'levelUp'
	)

	const laterialThinkingGames = (
		Object.values(GAME_TYPE) as GameType[]
	).filter((game) => game.gameCardPlacement === 'lateralThinking')

	const refineGames = (Object.values(GAME_TYPE) as GameType[]).filter(
		(game) => game.gameCardPlacement === 'refine'
	)

	return (
		<>
			<Box data-testid="home__container" sx={styles.container}>
				<Grid container data-testid="home__content" sx={styles.content}>
					<Grid
						data-testid="home__content_title"
						item
						px={6}
						sx={styles.homePage}
						xs={12}
					>
						<Typography
							data-testId="home__header"
							sx={styles.header}
						>
							Facilitation Techniques to Brainstorm Better
						</Typography>
					</Grid>
				</Grid>
				<GameCardSection
					data-testid="home__warmUp_game_cards"
					divider={true}
					padding={'60px'}
					filter={false}
					games={warmUpGames}
					title={'Get warmed up for your ideation'}
				/>
				<GameCardSection
					data-testid="home__levelUp_game_cards"
					divider={false}
					padding={'10px'}
					filter={true}
					games={levelUpGames}
					title={
						'Level up your creativity with lateral thinking techniques'
					}
				/>
				<GameCardSection
					data-testid="home__lateralThinking_game_cards"
					divider={false}
					padding={'10px'}
					filter={false}
					games={laterialThinkingGames}
					title={
						'Challenge your creativity with advanced lateral thinking techniques'
					}
				/>
				<GameCardSection
					data-testid="home__refine_game_cards"
					divider={true}
					padding={'50px'}
					filter={false}
					games={refineGames}
					title={'Refine your favorite ideas'}
				/>
				<Grid>
					<Grid
						data-testid="home__content_lower-container"
						item
						px={6}
						sx={styles.lowerContainer}
						xs={12}
					>
						<CallToAction homeVariant data-testid="home" />
					</Grid>
					<Box sx={styles.spacer} />
				</Grid>
			</Box>
		</>
	)
}

export default HomePage
